import { render, staticRenderFns } from "./AutomacaoProcessosItajai.vue?vue&type=template&id=59a5c6bd&scoped=true"
import script from "./AutomacaoProcessosItajai.vue?vue&type=script&lang=js"
export * from "./AutomacaoProcessosItajai.vue?vue&type=script&lang=js"
import style0 from "./AutomacaoProcessosItajai.vue?vue&type=style&index=0&id=59a5c6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a5c6bd",
  null
  
)

export default component.exports